import dynamic from 'next/dynamic';
import Head from 'next/head';

const LiveNoSSR = dynamic(() => import('../../components/Layout/Live/Layout'), { ssr: false });
export default function BlackFriday() {
  return (
    <>
      <Head>
        <title>Live | Canaltech</title>
        <meta name="theme-color" content="#27a9e1" />
        <meta name="viewport" content="width=device-width" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Live | Canaltech" />r
        <meta name="twitter:card" content="Live | Canaltech" />
      </Head>
      <LiveNoSSR />
    </>
  );
}
